import { collection, query, where, onSnapshot } from "firebase/firestore";
import * as dev_constants from '../constants/dev_constants';
import { db, getCheckSession, getIsAdmin } from "./auth";
import DeviceDataService from "./device-data";
import DashboardDataService from "./dashboard-data";
import { typeFilter } from "../constants/constants";
import { getSchedule } from "../query/dim-schedule.query";
import { isInsideSchedule } from "../utilities/dev_utils";
let lampDataInstance;
let unsub = undefined;
let lampFetchCompletionHandler = null;
let lampUpdateHandler = null;
let lampData = [];
let allLampData = [];
let lampsMap = new Map();
let lampPageIndex = 1;
let lampPageSize = 10;
export let isInitialLoadCompleted = false;

let lampFilters = {
    zone: 0,
    ward: 0,
    ccms: 0,
    status: 0,
}

let lampsCountsObject = {
    lmpCnt: 0,
    lmpOnCnt: 0,
    lmpOffCnt: 0,
    lmpErrCnt: 0,
    ilmCnt: 0,
    ilmOnCnt: 0,
    ilmOffCnt: 0,
    ilmErrCnt: 0,
};

let schedule = null;

const emptyLampDevice = {
    dev_id: "",
    dev_st: dev_constants.DeviceStatusNone,
}

let lampsUnsub = undefined;

class LampData {
    constructor() {
        if (lampDataInstance) {
            throw new Error("Instance already created");
        }
        lampDataInstance = this;
    }
    /** Expoeted functions*/
    getInstance() {
        return lampDataInstance;
    }

    // getCount() {
    //     return counter;
    //   }

    // increment() {
    // return ++counter;
    // }

    initService(completionHandlerArg, updateHandlerArg) {
        return new Promise((resolve) => {
            lampFetchCompletionHandler = () => {
                if (completionHandlerArg) completionHandlerArg();
                resolve();
            };
            lampUpdateHandler = updateHandlerArg;
            if (lampsMap.size > 0) {
                if (lampFetchCompletionHandler) lampFetchCompletionHandler();
            } else {
                this.fetchAllLamps();
            }
        });
    }

    deinit() {
        if (lampsUnsub) {
            lampsUnsub();
            lampsUnsub = undefined;
        }
        lampsMap = new Map();
        lampData = [];
        allLampData = [];
        schedule = null;
        lampFetchCompletionHandler = null;
        lampUpdateHandler = null;
    }

    setPageIndex(index) {
        lampPageIndex = index;
    }

    getPageIndex() {
        return lampPageIndex;
    }
    setPageSize(index) {
        lampPageSize = index;
    }

    getPageSize() {
        return lampPageSize;
    }

    setLampFilter(zoneId, wardId, ccmsId = 0, statusId = 0) {
        lampFilters.zone = zoneId;
        lampFilters.ward = wardId;
        lampFilters.ccms = ccmsId;
        lampFilters.status = statusId;
    }

    getLampFilter() {
        return lampFilters;
    }

    printLampCounts() {
        console.log("print counts ...");
        console.log(lampsCountsObject);
    }

    getCounts() {
        return lampsCountsObject;
    }

    refreshLampCounts() {
        this.recountAll();
        if (lampUpdateHandler) {
            lampUpdateHandler(null, null, lampData, allLampData);
        }
    }

    recountAll() {
        const { zone: zone = 0, ward: ward = 0, ccms: ccms = 0, slc_status: slc_status = typeFilter[0] } = DeviceDataService.getInstance().getDeviceFilter();
        // var city = this.getHeaderDetail("city");
        // if (city == "Tambaram") {
        //     lampsCountsObject.lmpCnt= 22413;
        //     lampsCountsObject.lmpOnCnt= 19117;
        //     lampsCountsObject.lmpOffCnt= 186;
        //     if (zone == 2) {
        //         lampsCountsObject.lmpCnt= 8075;
        //         lampsCountsObject.lmpOnCnt= 8025;
        //         lampsCountsObject.lmpOffCnt= 48;
        //     } else if (zone == 3) {
        //         lampsCountsObject.lmpCnt= 6139;
        //         lampsCountsObject.lmpOnCnt= 6086;
        //         lampsCountsObject.lmpOffCnt= 53;
        //     } else if (zone == 4) {
        //         lampsCountsObject.lmpCnt= 8199;
        //         lampsCountsObject.lmpOnCnt= 8138;
        //         lampsCountsObject.lmpOffCnt= 61;
        //     }
        // }
        // return lampsCountsObject;

        const filteredLamps = this.getLampsByFilter(zone, ward);
        lampsCountsObject.ilmCnt = 0;
        lampsCountsObject.ilmErrCnt = 0;
        lampsCountsObject.ilmOnCnt = 0;
        lampsCountsObject.ilmOffCnt = 0;
        lampsCountsObject.lmpCnt = 0;
        lampsCountsObject.lmpErrCnt = 0;
        lampsCountsObject.lmpOnCnt = 0;
        lampsCountsObject.lmpOffCnt = 0;

        for (var ilmData of filteredLamps.ilmList) {
            let data = null;
            if (slc_status === typeFilter[1]) {
                data = DeviceDataService.getInstance().getSlcDevice(ilmData.slc_id);
                if (!data?.dev_id) continue;
            }
            else if (slc_status === typeFilter[2]) {
                data = DeviceDataService.getInstance().getSlcDevice(ilmData.slc_id);
                if (data?.dev_id) continue;
            }
            
            if (!data) {
                data = DeviceDataService.getInstance().getSlcDevice(ilmData.slc_id);
            }

            if (ilmData?.ilm === true) {
                lampsCountsObject.ilmCnt++;
                let ilmStatus = this.getLampCountStatus(ilmData, data);
                
                if (ilmStatus === dev_constants.DeviceStatusOn) {
                    lampsCountsObject.ilmOnCnt++;
                } else {
                    lampsCountsObject.ilmOffCnt++;
                }
            }
        }

        for (var lamp of filteredLamps.lampList) {
            let data = null;

            if (slc_status === typeFilter[1]) {
                data = DeviceDataService.getInstance().getSlcDevice(lamp.slc_id);
                if (!data?.dev_id) continue;
            }
            else if (slc_status === typeFilter[2]) {
                data = DeviceDataService.getInstance().getSlcDevice(lamp.slc_id);
                if (data?.dev_id) continue;
            }
            
            if (!data) {
                data = DeviceDataService.getInstance().getSlcDevice(lamp.slc_id);
            }

            lampsCountsObject.lmpCnt++;
            
            let lampStatus = this.getLampCountStatus(lamp, data);

            if (lampStatus === dev_constants.DeviceStatusOn) {
                lampsCountsObject.lmpOnCnt++;
            } else {
                lampsCountsObject.lmpOffCnt++;
            }
        }

        return DashboardDataService.getInstance().getUpdatedDashboardData(lampsCountsObject, zone, ward);
    }

    getWorkingLampsCount() {
        let countsObject = {
            lmpCnt: 0,
            lmpOnCnt: 0,
            lmpOffCnt: 0,
            lmpErrCnt: 0,
            ilmCnt: 0,
            ilmOnCnt: 0,
            ilmOffCnt: 0,
            ilmErrCnt: 0
        };
        const activeFilters = DeviceDataService.getInstance().getDeviceFilter();
        for (const lamp of lampsMap.values()) {
            if (!this.shouldCountLamp(lamp, activeFilters.zone, activeFilters.ward)) continue;
            
            let data = DeviceDataService.getInstance().getSlcDevice(lamp.slc_id);
            let lampStatus = this.getLampCountStatus(lamp, data);
            
            countsObject.lmpCnt++;
            if (lampStatus === dev_constants.DeviceStatusOn) {
                countsObject.lmpOnCnt++;
            } else {
                countsObject.lmpOffCnt++;
            }

            if (lamp.ilm === true) {
                countsObject.ilmCnt++;
                if (lampStatus === dev_constants.DeviceStatusOn) {
                    countsObject.ilmOnCnt++;
                } else {
                    countsObject.ilmOffCnt++;
                }
            }
        }
        return countsObject;
    }

    // getCountsForMockData( zone = 0, ward = 0) {
    //      // var city = this.getHeaderDetail("city");
    //     // if (city == "Tambaram") {
    //     //     lampsCountsObject.lmpCnt= 22413;
    //     //     lampsCountsObject.lmpOnCnt= 19117;
    //     //     lampsCountsObject.lmpOffCnt= 186;
    //     //     if (zone == 2) {
    //     //         lampsCountsObject.lmpCnt= 8075;
    //     //         lampsCountsObject.lmpOnCnt= 8025;
    //     //         lampsCountsObject.lmpOffCnt= 48;
    //     //     } else if (zone == 3) {
    //     //         lampsCountsObject.lmpCnt= 6139;
    //     //         lampsCountsObject.lmpOnCnt= 6086;
    //     //         lampsCountsObject.lmpOffCnt= 53;
    //     //     } else if (zone == 4) {
    //     //         lampsCountsObject.lmpCnt= 8199;
    //     //         lampsCountsObject.lmpOnCnt= 8138;
    //     //         lampsCountsObject.lmpOffCnt= 61;
    //     //     }
    //     // }
    //     // return lampsCountsObject;

    //     const filteredLamps = this.getAllLamps();
    //     lampsCountsObject.ilmCnt = 0;
    //     lampsCountsObject.ilmErrCnt = 0;
    //     lampsCountsObject.ilmOnCnt = 0;
    //     lampsCountsObject.ilmOffCnt = 0;
    //     lampsCountsObject.lmpCnt = 0;
    //     lampsCountsObject.lmpErrCnt = 0;
    //     lampsCountsObject.lmpOnCnt = 0;
    //     lampsCountsObject.lmpOffCnt = 0;

    //     for (var ilmData of filteredLamps.ilmList) { 

    //         if (ilmData.ilm) {
    //             lampsCountsObject.ilmCnt++;
    //             if (ilmData.err_cnt > 0) {
    //                 lampsCountsObject.ilmErrCnt++;
    //             } else if (ilmData.dev_st === dev_constants.DeviceStatusOn) {
    //                 lampsCountsObject.ilmOnCnt++;
    //             } else {
    //                 lampsCountsObject.ilmOffCnt++;
    //             }
    //         }
    //     }

    //     for (var lamp of filteredLamps.lampList) {

    //         lampsCountsObject.lmpCnt++;

    //         if (lamp.dev_st === dev_constants.DeviceStatusOn) {
    //             lampsCountsObject.lmpOnCnt++;
    //         } else if (lamp.dev_st === dev_constants.DeviceStatusOff) {
    //             lampsCountsObject.lmpOffCnt++;
    //         } else {
    //             lampsCountsObject.lmpErrCnt++;
    //         }
    //     }

    //     return DashboardDataService.getInstance().getUpdatedDashboardData(lampsCountsObject, zone, ward);
    // }

    //Get user Info
    getHeaderDetail(propName) {
        let configResponse = localStorage.getItem("firebaseConfigApiResponse");
        let detail = "";
        if (configResponse) {
            configResponse = JSON.parse(configResponse);
            switch (propName) {
                case "email":
                default: {
                    detail = localStorage.getItem("userEmail") || "";
                    break;
                }
                case "city": {
                    detail = configResponse?.displayName;
                }
            }
        }
        return detail;
    }

    clearLampCounts(countsObject, devMap) {
        countsObject.lmpCnt = 0;
        countsObject.lmpOnCnt = 0;
        countsObject.lmpOffCnt = 0;
        countsObject.lmpErrCnt = 0;

        if (devMap !== undefined) {
            devMap.clear();
        }
    }

    isLampIdOn(devId) {
        let deviceData = lampsMap.get(devId);
        return this.isLampOn(deviceData);
    }

    isLampOn(deviceData) {
        if (deviceData != undefined) {
            if (deviceData.dev_st === dev_constants.DeviceStatusOn) {
                return true
            }
        }

        return false;
    }

    // setLampsFilter(zoneId, wardId) {
    //     let filterChanged = false;

    //     if (lampFilters.zone != zoneId) {
    //         lampFilters.zone = zoneId;
    //         filterChanged = true;
    //     }

    //     if (lampFilters.ward != wardId) {
    //         lampFilters.ward = wardId;
    //         filterChanged = true;
    //     }

    //     if (filterChanged) {
    //         this.recountAllLamps();
    //     }
    // }

    recountAllLamps() {
        this.clearLampCounts(lampsCountsObject, undefined);

        for (const devData of lampsMap.values()) {
            if (this.shouldCountLamp(devData, lampFilters.zone, lampFilters.ward)) {
                this.refreshCountsForDevice(devData);
            }
        };
    }

    getScheduleData() {
        return getSchedule().then((data) => {
            schedule = data;
        });
    }

    refreshCountsForDevice(deviceData) {
        this.updateCountsForLamp(emptyLampDevice, deviceData);
    }

    shouldCountLamp(deviceData, zoneId = 0, wardId = 0) {
        let result = false;
        if (zoneId === 0) {
            result = true;
        } else {
            if (wardId === 0) {
                if (zoneId === deviceData.zn_id || zoneId === deviceData.zn) {
                    result = true;
                }
            } else {
                if ((zoneId === deviceData.zn_id || zoneId === deviceData.zn) && (wardId === deviceData.wd_id || wardId === deviceData.wd)) {
                    result = true;
                }
            }
        }

        return result;
    }

    CountLamp(deviceData, zoneId = 0, wardId = 0) {
        // console.log(`Wardd${wardId} Zone${zoneId}`)
        // console.log(JSON.stringify(deviceData))
        let result = false;

        if (zoneId === 0) {
            result = true;
        } else {
            if (wardId === 0) {
                if (zoneId === deviceData.zn) {
                    result = true;
                }
            } else {
                if ((zoneId === deviceData.zn) && (wardId === deviceData.wd)) {
                    result = true;
                }
            }
        }
        return result;
    }

    // getLampsByFilter(zoneId, wardId, lamp = 0) {
    //     let result = {
    //         deviceListIds:[{label: "All", value: 0}],
    //         deviceList:[], 
    //     };

    //     for (const devData of lampsMap.values()) {
    //         if (this.shouldCountLamp(devData, zoneId, wardId)) {
    //             if (lamp === 0 || devData.dev_id === lamp) {
    //                 result.deviceListIds.push({label: devData.dev_id,value: devData.dev_id});
    //                 result.deviceList.push(devData)
    //             }
    //         }
    //     }

    //     return (result);
    // }

    getLampsByFilter(zoneId, wardId, slcId = 0) {
        let result = {
            deviceListIds: [{ label: "All", value: 0 }],
            ilmList: [],
            lampList: [],
        };

        for (const devData of lampsMap.values()) {
            // console.log(JSON.stringify(devData))
            if (this.CountLamp(devData, zoneId, wardId)) {
                if (devData['ilm'] === true && (slcId === 0 || devData.slc_id === slcId)) {
                    result.deviceListIds.push({ label: devData.dev_id, value: devData.dev_id });
                    result.ilmList.push(devData)
                } if (devData['dev_ty'] === dev_constants.DeviceTypeLamp) {
                    result.lampList.push(devData)
                }
            }
        }
        return (result);
    }

    getAllLamps() {
        let result = {
            ilmList: [],
            lampList: [],
        };

        for (const devData of lampsMap.values()) {
            // console.log(JSON.stringify(devData))
            if (devData['ilm'] === true) {
                result.ilmList.push(devData)
            } if (devData['dev_ty'] === dev_constants.DeviceTypeLamp) {
                result.lampList.push(devData)
            }
        }
        return (result);
    }
    getDeviceByDevId(devId) {
        for (const devData of lampsMap.values()) {
            if (devData['dev_ty'] === dev_constants.DeviceTypeLamp && devData['dev_id'] === devId) {
                return devData
            }
        }
    }

    getPagedLampsByFilter(zoneId, wardId, slcId = 0, status, page = 1, rowCount = 10) {
        lampData = [];
        allLampData = [];
        let result = {
            deviceListIds: [{ label: "All", value: 0 }],
            deviceList: [],
            allDeviceList: [],
            errorDeviceListIds: [{ label: "All", value: 0 }],
            errorDeviceList: [],
            pageNum: page,
            totalRecords: 0,
            totalPages: 0
        };

        // Around line 288 in lamps-data.js
        for (const devData of lampsMap.values()) {
            if (this.shouldCountLamp(devData, zoneId, wardId) && devData['ilm'] === true) {
                const deviceId = devData.ilm_id || devData.dev_id;
                result.deviceListIds.push({ label: deviceId, value: deviceId });

                // Use deviceId (ilm_id) for the ccms/slcId filter match
                if ((slcId === 0 || deviceId === slcId) && (status == 0 || (devData.dev_st === status))) {
                    result.deviceList.push(devData);
                }
            }
        }

        result.totalRecords = result.deviceList.length;

        if (result.totalRecords > 0) {
            result.totalPages = Math.ceil(result.totalRecords / rowCount);

            let startIndex = (page - 1) * rowCount;
            if (startIndex >= result.totalRecords) {
                startIndex = 0;
                result.pageNum = 1;
            }

            let endIndex = startIndex + rowCount;
            if (endIndex > result.totalRecords) {
                endIndex = result.totalRecords;
            }
            result.allDeviceList = result.deviceList;
            allLampData = result.deviceList;
            lampData = result.deviceList.slice(startIndex, endIndex);
            result.deviceList = result.deviceList.slice(startIndex, endIndex);
        }

        return result;
    }

    getLampsBySLC(slc) {
        let result = {
            deviceList: [],
            ilmDeviceList: [],
        };

        if (slc === null | undefined | "") {
            return (result);
        }

        var lamps = lampsMap.values();
        for (const devData of lamps) {
            if (devData["slc_id"] === slc) {
                result.deviceList.push(devData);
                if (devData['ilm'] === true) {
                    result.ilmDeviceList.push(devData);
                }
            }
        }

        return (result);
    }

    getLampsWattsByPid(pid) {
        let result = {
            deviceListIds: [{ label: "All", value: 0 }],
            deviceList: [],
        };

        if (pid === null | undefined | "") {
            return (result);
        }

        var lamps = lampsMap.values();

        for (const devData of lamps) {
            if (devData["pid"] === pid) {
                result.deviceList.push(devData['wt']);
            }
        }
        return (result);
    }
    getAllLamp() {
        const { zone: zone = 0, ward: ward = 0, ccms: ccms = 0 } = DeviceDataService.getInstance().getDeviceFilter();

        let result = {
            ilmList: [],
        };
        for (const devData of lampsMap.values()) {
            if (this.CountLamp(devData, zone, ward)) {
                if (devData['ilm'] === true) {
                    result.ilmList.push(devData)
                }
            }
        }
        return result;
    }
    getLampByPid(pid) {
        if (pid === null | undefined | "") {
            return [];
        }

        var lamps = lampsMap.values();

        for (const devData of lamps) {
            if (devData["pid"] === pid) {
                return devData;
            }
        }
    }

    fetchAllLamps() {
        if (!db()) {
            console.log("LampDataService: db is null, aborting fetchAllLamps");
            return;
        }
        try {
            let newRequest = true;
            let hasReceivedServerSnapshot = false;
            let lastCallbackTime = new Date();
            let avgTimeMilliSecs = 0;
            const lampStartTime = Date.now();

            const q = query(collection(db(), "devices"),
                where("dev_ty", "==", dev_constants.DeviceTypeLamp));

            // lampsUnsub = db.collection('devices')
            //     .where('dev_ty', '==', dev_constants.DeviceTypeLamp)
            //     .onSnapshot(querySnapshot => {
            lampsUnsub = onSnapshot(q, (snapshot) => {
                snapshot.docChanges().forEach(change => {
                    let docData = change.doc.data();

                    if (newRequest) {
                        let currTime = new Date();
                        let milliSecsSinceLastResp = currTime.getTime() - lastCallbackTime.getTime();
                        if (lampsMap.size === 0) {
                            avgTimeMilliSecs = milliSecsSinceLastResp;
                        } else {
                            avgTimeMilliSecs = (avgTimeMilliSecs + milliSecsSinceLastResp) / 2;
                        }
                        lastCallbackTime = new Date();
                    }

                    if (this.shouldCountLamp(docData, lampFilters.zone, lampFilters.ward)) {
                        // if (docData["dev_id"] == 'ILM002') {
                        //     // debugger;
                        //     console.log("Device 002");
                        // }
                        if (change.type === "added") {
                            this.addCountsForNewLamp(docData);
                        } else if (change.type === "modified") {
                            this.modifyCountsForExistingLamp(docData);
                        } else if (change.type === "removed") {
                            this.deleteCountsForExistingLamp(docData);
                        } else {
                            this.addToLampsMap(docData, change.type);
                        }

                        if (!newRequest && lampUpdateHandler != null) {
                            lampUpdateHandler(docData, change.type, lampData, allLampData);
                        }
                    }
                });
                if (newRequest) {
                    const timeTaken = Date.now() - lampStartTime;
                    console.log(`[PERF] Initial Lamp Snapshot Fetch: ${timeTaken}ms (From Cache: ${snapshot.metadata.fromCache}). Total Lamps fetched: ${snapshot.size}`);
                    newRequest = false;
                    isInitialLoadCompleted = true;
                    if (!snapshot.metadata.fromCache) {
                        hasReceivedServerSnapshot = true;
                    }
                    this.recountAll();
                    if (lampFetchCompletionHandler) {
                        lampFetchCompletionHandler();
                    }
                } else if (!hasReceivedServerSnapshot && !snapshot.metadata.fromCache) {
                    hasReceivedServerSnapshot = true;
                    console.log(`[PERF] First Lamp Server Snapshot Received. Triggering UI refresh.`);
                    this.recountAll();
                    if (lampFetchCompletionHandler) {
                        lampFetchCompletionHandler();
                    }
                }

            }, (error) => {
                console.log("lamps snapshot listen error: reconnecting in 30 secs");
                setTimeout(() => this.reconnectLampsSnapshot(), 30000);
            });

            const checkLastCallbackTimerId = setInterval(() => checkLastCallback(), 1000);

            const checkLastCallback = () => {
                let waitMilliSecs = 0;
                let currTime = new Date();
                let milliSecsSinceLastResp = currTime.getTime() - lastCallbackTime.getTime();

                if (lampsMap.size === 0) {
                    waitMilliSecs = 30000;
                } else {
                    waitMilliSecs = avgTimeMilliSecs * 2;
                    if (waitMilliSecs < 1000) {
                        waitMilliSecs = 1000;
                    }
                }

                if (milliSecsSinceLastResp > waitMilliSecs) {
                    newRequest = false;
                    isInitialLoadCompleted = true;
                    this.recountAll();
                    clearInterval(checkLastCallbackTimerId);
                }
            }

            setTimeout(() => LampDataService.getInstance().checkLampsData(), 60000);
        } catch (err) {
            // callback needed?
            // debugger;
            console.log("lamp-data.js", err)
            alert('Unable to load lamp data, please try after some time.');
        }
    }

    checkLampsData() {
        if (lampsMap.size == 0) {
            console.log("no lamps received. fetching again");
            if (lampsUnsub != undefined) {
                console.log("stopping listener");
                lampsUnsub();
            }
            this.fetchAllLamps();
        } else {
            console.log("data found");
        }
    }

    reconnectLampsSnapshot() {
        console.log("stopping listener");
        if (lampsUnsub != undefined) {
            lampsUnsub();
        }
        this.clearLampCounts(lampsCountsObject, lampsMap);
        console.log("fetching devices again");
        this.fetchAllLamps();
        setTimeout(() => this.printLampCounts(), 5000);
    }

    addCountsForNewLamp(newDeviceData) {
        let oldDeviceData = lampsMap.get(newDeviceData.dev_id);
        let isDevAlrdyCached = (oldDeviceData !== undefined);

        if (isDevAlrdyCached) {
            // should not come here
            // console.log("error: new device", newDeviceData.dev_id, "already in cache");
            this.deleteCountsForExistingLamp(oldDeviceData)
        }
        newDeviceData.slc = this.getSlc(newDeviceData);
        this.updateCountsForLamp(emptyLampDevice, newDeviceData);

        lampsMap.set(newDeviceData.dev_id, newDeviceData)
        // console.log("added", newDeviceData.dev_id);
    }

    modifyCountsForExistingLamp(newDeviceData) {
        let oldDeviceData = lampsMap.get(newDeviceData.dev_id);
        let isDevAlrdyCached = (oldDeviceData !== undefined);

        if (isDevAlrdyCached) {
            newDeviceData.slc = this.getSlc(newDeviceData);
            this.updateCountsForLamp(oldDeviceData, newDeviceData);
            lampsMap.set(newDeviceData.dev_id, newDeviceData)
            // console.log("updated", newDeviceData.dev_id);
        } else {
            // should not come here
            console.log("error: modified device", newDeviceData.dev_id, "not found in cache");
        }
    }

    updateCountsForLamp(oldDeviceData, newDeviceData) {
        this.updateLampCount(oldDeviceData, newDeviceData);
    }

    getLampCountStatus(lampData, slcData) {
        if (!lampData || !lampData.dev_id) return dev_constants.DeviceStatusNone;
        if (getIsAdmin()) return lampData.dev_st;

        if (!slcData || !slcData.dev_id) {
            const isInside = DashboardDataService.getInstance().isGlobalScheduleActive();
            const currentTime = new Date();
            const lampLastSeen = lampData.ls ? new Date(lampData.ls.seconds * 1000) : new Date(0);
            const diffMinutes = (currentTime - lampLastSeen) / 1000 / 60;

            if (isInside) {
                if (lampData.dev_st === dev_constants.DeviceStatusOn) {
                    return dev_constants.DeviceStatusOn;
                } else {
                    if (diffMinutes < 35) {
                        return lampData.dev_st;
                    } else {
                        return dev_constants.DeviceStatusOn; // Active logic defaults to ON if inactive for >35m in schedule
                    }
                }
            } else {
                return dev_constants.DeviceStatusOff;
            }
        }

        const slcStatus = DeviceDataService.getInstance().getSlcCountStatus(slcData);
        
        if (slcStatus === dev_constants.DeviceStatusOn) {
            return dev_constants.DeviceStatusOn;
        } else {
            // console.log(`Lamp ${lampData.dev_id} is OFF because slcStatus of SLC ${slcData.dev_id} is OFF. slcData.dev_st is ${slcData.dev_st}`);
            return dev_constants.DeviceStatusOff;
        }
    }

    updateLampCount(oldDeviceData, newDeviceData) {
        if (oldDeviceData.dev_id !== newDeviceData.dev_id) {
            lampsCountsObject.lmpCnt++;
        }

        let slcOld = this.getSlc({ slc_id: oldDeviceData.slc_id });
        let slcNew = this.getSlc({ slc_id: newDeviceData.slc_id });

        const oldStatus = this.getLampCountStatus(oldDeviceData, slcOld);
        const newStatus = this.getLampCountStatus(newDeviceData, slcNew);

        if (newStatus === dev_constants.DeviceStatusOn) {
            if (oldStatus === dev_constants.DeviceStatusOff || oldStatus === dev_constants.DeviceStatusNone) {
                lampsCountsObject.lmpOnCnt++;
                if (oldStatus === dev_constants.DeviceStatusOff && lampsCountsObject.lmpOffCnt > 0) {
                    lampsCountsObject.lmpOffCnt--;
                }
            }
        } else if (newStatus === dev_constants.DeviceStatusOff) {
            if (oldStatus === dev_constants.DeviceStatusOn || oldStatus === dev_constants.DeviceStatusNone) {
                lampsCountsObject.lmpOffCnt++;
                if (oldStatus === dev_constants.DeviceStatusOn && lampsCountsObject.lmpOnCnt > 0) {
                    lampsCountsObject.lmpOnCnt--;
                }
            }
        }
    }

    deleteCountsForExistingLamp(newDeviceData) {
        let oldDeviceData = lampsMap.get(newDeviceData.dev_id);
        let isDevAlrdyCached = (oldDeviceData !== undefined);

        if (!isDevAlrdyCached) {
            console.log("error: lamp to delete", newDeviceData.dev_id, "not found in cache");
            return;
        }

        if (lampsCountsObject.lmpCnt > 0) {
            lampsCountsObject.lmpCnt--;
        }

        let slcOld = this.getSlc({ slc_id: oldDeviceData.slc_id });
        const oldStatus = this.getLampCountStatus(oldDeviceData, slcOld);

        if (oldStatus === dev_constants.DeviceStatusOn) {
            if (lampsCountsObject.lmpOnCnt > 0) {
                lampsCountsObject.lmpOnCnt--;
            }
        } else if (oldStatus === dev_constants.DeviceStatusOff) {
            if (lampsCountsObject.lmpOffCnt > 0) {
                lampsCountsObject.lmpOffCnt--;
            }
        }

        lampsMap.delete(oldDeviceData.dev_id);
    }

    getSlc({ slc_id: slc_id = "" }) {
        return DeviceDataService.getInstance().getSlcDevice(slc_id);
    }


}

const LampDataService = Object.freeze(new LampData());
export default LampDataService;